import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { ConsentService } from 'app/services/consent.service';
import { MatIconModule } from '@angular/material/icon';
import { FerrerAuthService } from 'app/services/authentication.service';
import { IframeSecurityService } from 'app/services/iframeSecurity.service';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { OtpSuggestDialogComponent } from '../otp-suggest/otpsuggestpwd-dialog.component';
import { SessionService } from 'app/services/session.service';
@Component({
  selector: 'app-diffCountry-consent',
  templateUrl: './diffcountry-dialog.component.html',
  styleUrls: ['./diffcountry-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoPipe,
    MatIconModule
  ],
})
export class DiffCountryDialogComponent {
  email: string;
  userCurrentCountry: string;
  password?: string;
  otpCode?: string;
  userConsent = [];
  isLoading: boolean = false;
  mainConsent: boolean = false;
  subConsent1: boolean = false;
  subConsent2: boolean = false;
  disableMain: boolean = false;
  disableSubs: boolean = false;
  subConsents: { contentType: string; checked: boolean; content: string }[] = [];
  apiError: string = '';
  private allSubConsents: any[] = [];
  public titleParams = { suffix: '' }; // Initialize empty

  constructor(
    private dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ferrerAuth: FerrerAuthService,
    private iframeSecurityService: IframeSecurityService,
    private consentService: ConsentService,
    private dialogUtilsService: DialogUtilsService,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {

    this.email = this.data.email;
    if (this.data.otpCode) {
      this.otpCode = this.data.otpCode;
    } else if (this.data.password) {
      this.password = this.data.password;
    } else {
      console.error('Invalid data structure received in ConsentDialogComponent');
    }
    if (this.data.consentsAceptados) {
      this.userConsent = this.data.consentsAceptados;
    }
    if (this.data.userCountry) {
      this.userCurrentCountry = this.data.userCountry;
    }
    this.titleParams = { suffix: '' };


    this.sessionService.digitalAsset$.subscribe(digitalAsset => {
      if (digitalAsset) {

        this.titleParams = { suffix: digitalAsset };
      }
    });
    const cachedConsent = localStorage.getItem('ferrer_consentcache');
    const cachedTimestamp = localStorage.getItem('ferrer_consentcache_timestamp');
    this.email = this.data.email;
    const now = new Date().getTime();
    const expirationTime = 24 * 60 * 60 * 1000;

    this.consentService.getConsent(this.getCurrentCountry()).subscribe((consentContent) => {
      if (consentContent != undefined) {
        localStorage.setItem('ferrer_consentcache_timestamp', now.toString());
        localStorage.setItem('ferrer_consentcache', JSON.stringify(consentContent));
      }

      this.allSubConsents = consentContent.consents.map((item: any) => ({
        contentType: item.id,
        checked: false,
        content: item.detailedDescription
      }));

      this.subConsents = this.allSubConsents.map(consent => ({ ...consent }));

      this.filterUnacceptedConsents();
    });


    // }
  }
  shouldShowCloseButton(): boolean {
    return true;
  }
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  onMainConsentChange(): void {
    const isChecked = this.mainConsent;
    this.subConsents.forEach(sub => sub.checked = isChecked);
  }

  onSubConsentChange(): void {
    // Check if any subConsent is checked
    this.mainConsent = this.subConsents.every(sub => sub.checked);
  }
  close(): void {
    this.dialogUtilsService.closeDialog(this.dialogRef);
  }
  login(): void {
    //login action sending the consent selections
    // it will depend if the frist ones are checked or not,and well sent the user selections to the back
    this.updateAllConsentsFromDisplayed();

    this.apiError = '';
    const requestBody: any = {
      email: this.email,
      rememberMe: true,
      eConsents: this.allSubConsents
    };
    if (this.password) {
      // Password-based authentication
      requestBody.password = this.password;
    } else if (this.otpCode) {
      // OTP-based authentication
      requestBody.otpPassword = this.otpCode;
    } else {
      console.error('No authentication method available');

    }
    const parentOrigin = this.iframeSecurityService.getParentOrigin();

    this.isLoading = true;
    const subconsentsDict = this.allSubConsents.reduce((dict, consent) => {
      dict[consent.contentType] = consent.checked;
      return dict;
    }, {} as Record<string, boolean>);

    this.ferrerAuth.login(this.email, this.password, this.otpCode, subconsentsDict)
      .subscribe({
        next: (response) => {

          this.isLoading = false;
          if (response && response.userAccess?.success === true) {
            // variara segun el contenido
            if (this.otpCode) {
              this.openpwdChangeDialog(response);
              return;
            }
            const isInIframe = this.isRunningInIframe();

            if (isInIframe) {
              // We're in an iframe, post message to parent

              if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                  type: 'loginSuccess',
                  userData: {
                    email: this.email
                  }
                }, '*');
              }
            } else {
              // Not in an iframe, open in new tab

              this.dialogRef.close("response");

              // Navigate to the returnUrl in the same tab
              window.location.href = response.returnUrl;


            }
            // Close the dialog
            this.dialogRef.close("response");
          } else {
            this.isLoading = false;

            this.handleApiError(response);
          }
        },
        error: (err) => {
          console.error('Login failed', err)
          this.isLoading = false;
          this.handleApiError(err);
        }
      });

  }


  getCurrentCountry(): string {

    if (this.userCurrentCountry) {
      return this.userCurrentCountry;
    }
    return 'ES';
  }

  handleApiError(error: any): void {

    // Get error response body
    const errorBody = error.error.message || error.error || error;
    console.log(error.error);
    console.log(errorBody);
    this.apiError = errorBody;
  }
  private isRunningInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we get a security error, we're definitely in an iframe
      return true;
    }
  }

  openpwdChangeDialog(response?: any): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this.dialogRef = this._dialog.open(OtpSuggestDialogComponent, {
      width: `${width}px`,

      maxWidth: '90vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        apiResponse: response,
        email: this.email
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this.dialogRef);

    this.dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this.dialogRef = null;
    });
  }

  filterUnacceptedConsents(): void {
    // First check if userConsent exists and has data
    if (!this.userConsent) {
      // If no user consents available, keep all subconsents

      return;
    }

    this.subConsents = this.subConsents.filter(subConsent => {
      const consentId = subConsent.contentType;

      const isAccepted = this.userConsent[consentId];
      // Keep only if consent is false or not defined
      return isAccepted === false || isAccepted === undefined;
    });

  }
  private updateAllConsentsFromDisplayed(): void {
    const displayedConsentsMap = {};

    this.subConsents.forEach(consent => {
      displayedConsentsMap[consent.contentType] = consent.checked;
    });

    for (let i = 0; i < this.allSubConsents.length; i++) {
      const consent = this.allSubConsents[i];
      const consentId = consent.contentType;

      if (displayedConsentsMap[consentId] !== undefined) {
        consent.checked = displayedConsentsMap[consentId];
      } else {
        consent.checked = true;
      }
    }
  }
}